import React from 'react';
import Icon from '../../../components/AppIcon';

const STAGES = [
  { id: 'lead', label: 'Prospect', tone: 'bg-sky-500/90' },
  { id: 'qualified', label: 'Qualifié', tone: 'bg-emerald-500/90' },
  { id: 'proposal', label: 'Proposition', tone: 'bg-amber-500/90' },
  { id: 'negotiation', label: 'Négociation', tone: 'bg-orange-500/90' },
  { id: 'closed', label: 'Conclu', tone: 'bg-primary/90' },
];

const PipelineStageFlow = ({ data }) => {
  const stages = STAGES.map((s) => ({
    ...s,
    count: data?.[s.id] || 0,
  }));

  const totalProspects = stages.reduce((sum, s) => sum + s.count, 0);
  const leadToClosed =
    stages[0].count > 0
      ? ((stages[4].count / stages[0].count) * 100).toFixed(1)
      : '0';

  return (
    <div className="rounded-2xl border border-border/80 bg-card p-5 shadow-sm md:p-6">
      <div className="mb-5 flex flex-wrap items-center justify-between gap-3">
        <div>
          <h3 className="text-base font-semibold text-foreground md:text-lg">Répartition par étape</h3>
          <p className="text-sm text-muted-foreground">
            Où en sont vos prospects dans le cycle de vente
          </p>
        </div>
        <div className="inline-flex items-center gap-2 rounded-full bg-muted px-3 py-1.5 text-sm text-muted-foreground">
          <Icon name="Users" size={16} />
          <span className="font-medium text-foreground tabular-nums">{totalProspects}</span>
          <span>au total</span>
        </div>
      </div>

      {totalProspects === 0 ? (
        <p className="rounded-xl border border-dashed border-border bg-muted/15 px-4 py-12 text-center text-sm text-muted-foreground">
          Aucun prospect dans ce périmètre. Changez de campagne ou élargissez le filtre.
        </p>
      ) : (
        <>
          <div className="mb-4 hidden h-2 overflow-hidden rounded-full bg-muted sm:flex">
            {stages.map((stage) => {
              const pct = totalProspects > 0 ? (stage.count / totalProspects) * 100 : 0;
              if (pct <= 0) return null;
              return (
                <div
                  key={stage.id}
                  className={`h-full ${stage.tone} transition-all`}
                  style={{ width: `${pct}%` }}
                  title={`${stage.label}: ${stage.count}`}
                />
              );
            })}
          </div>

          <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-5">
            {stages.map((stage) => {
              const pct =
                totalProspects > 0
                  ? Math.round((stage.count / totalProspects) * 100)
                  : 0;
              return (
                <div
                  key={stage.id}
                  className="rounded-xl border border-border/70 bg-muted/10 p-4 text-center transition-colors hover:bg-muted/25"
                >
                  <p className="text-2xl font-semibold tabular-nums text-foreground md:text-3xl">
                    {stage.count}
                  </p>
                  <p className="mt-1 text-xs font-medium text-foreground">{stage.label}</p>
                  <p className="mt-0.5 text-[11px] text-muted-foreground">{pct} % du pipeline</p>
                  <div className="mx-auto mt-3 h-1 max-w-[80%] overflow-hidden rounded-full bg-muted">
                    <div
                      className={`h-full rounded-full ${stage.tone}`}
                      style={{ width: `${Math.max(pct, stage.count > 0 ? 8 : 0)}%` }}
                    />
                  </div>
                </div>
              );
            })}
          </div>

          <p className="mt-5 text-center text-xs text-muted-foreground">
            Conversion prospect → conclu :{' '}
            <span className="font-semibold text-foreground">{leadToClosed} %</span>
          </p>
        </>
      )}
    </div>
  );
};

export default PipelineStageFlow;
